import React, { useState } from 'react';
import Wrapper from './BorrowingCostRatesHeader/Wrapper';
import { useNavigate, useParams } from 'react-router-dom';

export default function ({
  isVarSheet = false,
  isAnnualPremiaSheet = false,
  activeTab = 'Borrowing_Cost_Rates',
}) {
  let { uuid } = useParams();
  const [mode, setMode] = useState(uuid === undefined ? 'list' : 'single');
  const [action, setAction] = useState('view');

  const [iframeDimensions, setIframeDimensions] = React.useState({
    height: 0,
    width: 0,
  });

  React.useEffect(() => {
    const div = document.getElementById('iframe-container');
    if (div) {
      if (div?.clientHeight && div?.clientWidth) {
        setIframeDimensions({
          height: div.clientHeight,
          width: div.clientWidth,
        });
      }
    }
  }, []);

  const getSheetUrl = () => {
    if (isVarSheet) {
      return process.env.NX_PUBLIC_VAR_SHEET_URL;
    }
    if (isAnnualPremiaSheet) {
      return process.env.NX_PUBLIC_ANNUALISED_PREMIA_SHEET_URL;
    }
    return 'https://docs.google.com/spreadsheets/d/13_hdBkViehvl3kO9GMta6g4JkShQcu5o/edit?gid=485172178#gid=485172178';
  };

  const getHeader = () => {
    if (activeTab === 'Var_Analysis_Sheet') {
      return 'Var Sheet';
    }
    if (activeTab === 'Annualised_Premia') {
      return 'Annualised Premia';
    }
    return 'Borrowing Cost Rates';
  };

  return (
    <Wrapper
      topBarActiveOption={activeTab}
      isHidePublishButton={
        activeTab === 'Borrowing_Cost_Rates' ||
        activeTab === 'Annualised_Premia'
      }
      headers={getHeader()}
    >
      <div id="iframe-container" className="h-full w-[98%] px-1">
        <iframe
          src={getSheetUrl()}
          height={iframeDimensions.height || 600}
          width={iframeDimensions.width || 670}
        />
      </div>
    </Wrapper>
  );
}
